import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "../../styles/PagesStyling/AdminPage.css";
import { CurrentUsers } from "../AdminComponents/CurrentUsers";
import EditProjects from "../AdminComponents/EditProjects";
import EditSponsor from "../AdminComponents/EditSponsor";
import EditElasticSearch from "../AdminComponents/EditElasticSearch";
import AdminEditUser from "../AdminComponents/AdminEdit";
import { ChangePassword } from "../HomeComponents/ChangePassword";

export const AdminPage = ({
  isLoggedIn,
  setIsLoggedIn,
  userData,
  setUserData,
}) => {
  const navigate = useNavigate();
  const WorkManagement = `${process.env.PUBLIC_URL}/assets/logos/work-management.svg`;
  const ElasticInfo = `${process.env.PUBLIC_URL}/assets/logos/elastic-info.svg`;
  const Back = `${process.env.PUBLIC_URL}/assets/logos/back.svg`;
  const ManageUsers = `${process.env.PUBLIC_URL}/assets/logos/manage-users.svg`;
  const ManageUsersDark = `${process.env.PUBLIC_URL}/assets/logos/manage-users-dark.svg`;
  const ManageSponsors = `${process.env.PUBLIC_URL}/assets/logos/manage-sponsors.svg`;
  const ManageSponsorsDark = `${process.env.PUBLIC_URL}/assets/logos/manage-sponsors-dark.svg`;
  const ManageProjects = `${process.env.PUBLIC_URL}/assets/logos/manage-projects.svg`;
  const ManageProjectsDark = `${process.env.PUBLIC_URL}/assets/logos/manage-projects-dark.svg`;

  const [activeTab, setActiveTab] = useState("users"); // "users", "sponsors", "projects"
  const [showDropdown, setShowDropdown] = useState(false);
  const [showChangePassword, setShowChangePassword] = useState(false);
  const [refreshUsers, setRefreshUsers] = useState(0);
  const [editUserId, setEditUserId] = useState(null);

  const handleLogout = async () => {
    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/logout`,
        {},
        { withCredentials: true }
      );
      setUserData(null);
      setIsLoggedIn(false);
      setShowDropdown(false);
      navigate("/");
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  return (
    <div className="admin-page">
      <div className="admin-header">
        <button
          className="back-to-dashboard-btn"
          style={{ margin: "0 10px" }}
          onClick={() => navigate("/")}
        >
          <img
            src={Back}
            alt="Workspace Management"
            className="workspace-icon"
            title="Back to Dashboard"
          />
        </button>
        <div
          className="header-column actions"
          style={{ justifyContent: "flex-start" }}
        >
          {!isLoggedIn && !userData ? (
            <>{/* Your login form code here */}</>
          ) : (
            <>
              <div
                className="user-dropdown"
                onMouseLeave={() => setShowDropdown(false)}
              >
                <button
                  className="user-btn"
                  title="User Control Panel"
                  onClick={() => setShowDropdown(!showDropdown)}
                >
                  {userData?.FName?.[0]}
                  {userData?.LName?.[0]}
                </button>
                {showDropdown && (
                  <div
                    className="dropdown-menu"
                    style={{
                      right: `${
                        userData?.Role.includes("Admin")
                          ? "calc(14vh + 30px)"
                          : "calc(7vh + 20px)"
                      }`,
                    }}
                  >
                    <button onClick={() => setShowChangePassword(true)}>
                      Change Password
                    </button>
                    <button onClick={handleLogout}>Log Out</button>
                  </div>
                )}
              </div>
              <button className="user-btn" style={{ marginLeft: "10px" }} onClick={() => navigate("/learn-more")}>
                <img
                  src={ElasticInfo}
                  alt="Workspace Management"
                  className="workspace-icon"
                  title="Learn More Elastic Search"
                />
              </button>
            </>
          )}
          {isLoggedIn && userData?.Role.includes("Admin") && (
            <button
              className="workspace-btn"
              title="Admin Control Panel"
              onClick={() => navigate("/admin")}
            >
              <img
                src={WorkManagement}
                alt="Workspace Management"
                className="workspace-icon"
              />
            </button>
          )}
          {showChangePassword && (
            <div className="modal-overlay">
              <div className="change-password-modal-content">
                <ChangePassword
                  email={userData?.Email}
                  setShowChangePassword={setShowChangePassword}
                  onBack={() => setShowChangePassword(false)}
                />
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="admin-container">
        <div className="admin-div">
          <h1>Admin Workspace</h1>
          <div className="admin-actions">
            <button
              className={`admin-btn ${activeTab === "users" ? "active" : ""}`}
              onClick={() => setActiveTab("users")}
            >
              <img
                src={activeTab === "users" ? ManageUsers : ManageUsersDark}
                alt=""
                style={{ marginRight: "10px" }}
              />
              Manage Users
            </button>
            <button
              className={`admin-btn ${
                activeTab === "sponsors" ? "active" : ""
              }`}
              onClick={() => setActiveTab("sponsors")}
            >
              <img
                src={
                  activeTab === "sponsors" ? ManageSponsors : ManageSponsorsDark
                }
                alt=""
                style={{ marginRight: "10px" }}
              />
              Manage Sponsors
            </button>
            <button
              className={`admin-btn ${
                activeTab === "projects" ? "active" : ""
              }`}
              onClick={() => setActiveTab("projects")}
            >
              <img
                src={
                  activeTab === "projects" ? ManageProjects : ManageProjectsDark
                }
                alt=""
                style={{ marginRight: "10px" }}
              />
              Manage Projects
            </button>
            <button
              className={`admin-btn ${
                activeTab === "elasticsearch" ? "active" : ""
              }`}
              onClick={() => setActiveTab("elasticsearch")}
            >
              <img
                src={
                  activeTab === "elasticsearch" ? ManageSponsors : ManageSponsorsDark
                }
                alt=""
                style={{ marginRight: "10px" }}
              />
              Manage ElasticSearch
            </button>
          </div>

          <div className="tab-content">
            {activeTab === "users" && (
              <CurrentUsers
                onEditUser={(id) => setEditUserId(id)}
                refreshTrigger={refreshUsers}
                activeTab={activeTab}
                setRefreshUsers={setRefreshUsers}
              />
            )}
            {activeTab === "sponsors" && <EditSponsor activeTab={activeTab} />}
            {activeTab === "projects" && <EditProjects activeTab={activeTab} />}
            {activeTab === "elasticsearch" && (
              <EditElasticSearch activeTab={activeTab} />
            )}
          </div>

          {editUserId && (
            <div className="modal-overlay">
              <AdminEditUser
                userId={editUserId}
                onClose={() => setEditUserId(null)}
                onSave={() => setRefreshUsers((prev) => prev + 1)}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminPage;
